module.exports = __webpack_public_path__ + "static/nollvision_logo-0730c8a4b8ff1742cb43b3870b454d83.png";